import { create } from "zustand";

type DrawerState = {
  isDrawerOpen: boolean;
  // Actions
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
};

export const useDrawerState = create<DrawerState>(set => ({
  // Initial state
  isDrawerOpen: false,

  // Open drawer
  openDrawer: () =>
    set(() => ({ isDrawerOpen: true })),

  // Close drawer
  closeDrawer: () =>
    set(() => ({ isDrawerOpen: false })),

  // Toggle drawer
  toggleDrawer: () =>
    set(state => ({ isDrawerOpen: !state.isDrawerOpen })),
}));
